<template>
  <div>
    <!-- Loader  -->
    <div
      v-if="loader"
      class="fixed inset-0 flex items-center justify-center bg-white  z-50"
    >
      <img
        src="@/assets/imgs/tuin_loader_v2.gif"
        alt="cargando..."
        class=" w-[500px]"
      >
    </div>
    <!-- Loader  -->

    <ToastAlert
      :is-active="toastAlert"
      :type="typeMsg"
      :message="msg"
    />
    <div class="flex max-w-[1440px] mx-auto h-full font-poppins bg-white">
      <!--Left Panel-->
      <div
        v-if="page_view == 'login'"
        class="w-full sm:w-1/2 flex flex-col bg-white min-h-screen"
      >
        <!--Asesores logo-->
        <HeaderComponent class="md:mb-[110px] mb-10"/>
        <!-- card -->
        <div class="mx-auto px-5 md:p-0 md:ml-[80px] w-full max-w-sm bg-white border-gray-200 ">
          <h2 class="text-custom_black2 lg:text-3xl text-xl not-italic font-medium mb-1">
            Restablecer contraseña
          </h2>
          <span class="text-custom_black2 text-base font-normal not-italic">Para restablecer tu contraseña ingrese su correo electrónico.</span>
          <div class="lg:mt-4 mt-7 mb-[34px]">
            <div class="mb-2">
              <label for="email-input" class="block text-sm font-medium text-custom_gray">Correo</label>
              <input
                id="email-input"
                v-model="email"
                type="email"
                required
                placeholder="Ingresa tu correo"
                @input="clearEmailErrorIfNotEmpty"
                :class="[
                  'mt-1 block border text-custom_gray text-sm rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 w-full p-2.5',
                  emailError ? 'border-red-500 bg-red-50' : 'border-gray-300 bg-white'
                ]"
              />
            </div>
            <p v-if="emailError" class="text-red-500 text-sm font-medium mt-1 block">{{ emailErrorMessage }}</p>
          </div>
          <button
            class="w-full py-2 bg-tuin-100 hover:bg-tuin_hover rounded-md text-white font-semibold"
            @click="Restore()"
          >
            Enviar Correo
          </button>
          <div class="mt-6 text-center">
            <RouterLink
              to="/"
              class="text-[12px] md:text-sm text-tuin_base-0 hover:underline"
            >
              Regresar al inicio de Sesión
            </RouterLink>
          </div>
        </div>
      </div>
      <div class="hidden w-1/2 sm:flex items-center justify-center">
        <div>
          <img
            src="@/assets/imgs/undraw_mobile-encryption_flk2.svg"
            alt="Tuin hora de hacer magia"
            class="w-auto h-auto"
          >
        </div>
      </div>
    </div>
    <!--Old design-->
    <div class="hidden min-h-screen bg-dark_bg-100 text-white h-full">
      <div class="hidden w-1/2 sm:flex items-center justify-center">
        <div>
          <img
            src="@/assets/imgs/door.jpg"
            alt="Tuin hora de hacer magia"
            class="w-full h-full max-h-screen rounded-lg shadow-lg"
          >
        </div>
      </div>

      <div
        v-if="page_view == 'login'"
        class="w-full sm:w-1/2 flex flex-col items-center justify-center bg-black min-h-screen"
      >
        <img
          src="@/assets/imgs/LogoTuin.svg"
          alt="Logo"
          class="object-contain"
        >
        <h3 class="mb-6">
          Asesores
        </h3>
        <!-- card -->
        <div class="w-3/4 max-w-md bg-dark_bg-100 p-5 rounded-sm">
          <h2 class="text-2xl font-semibold mb-6">
            Recuperar contraseña
          </h2>
          <div class="mb-4">
            <div class="mb-2">
              <label for="email-input-2" class="block text-sm font-medium text-white">Email</label>
              <input
                id="email-input-2"
                v-model="email"
                type="email"
                required
                placeholder="Introduce tu correo electrónico"
                @input="clearEmailErrorIfNotEmpty"
                :class="[
                  'mt-1 block w-full rounded-md shadow-sm bg-dark_bg-100 text-white border-gray-600 focus:border-tuin-100 focus:ring-tuin-100',
                  emailError ? 'border-red-500 bg-red-50' : ''
                ]"
              />
            </div>
            <p v-if="emailError" class="mt-1 text-sm font-medium text-red-600">{{ emailErrorMessage }}</p>
          </div>
          
          
          <button
            class="w-full py-2 bg-tuin-100 hover:bg-tuin-100 rounded-md text-white font-semibold"
            @click="Restore()"
          >
            Recuperar
          </button>
          <div class="mt-4 text-center">
            <router-link
              to="/login"
              class="text-tuin-100 text-sm cursor-pointer"
            >
              Ya tengo una cuenta 
            </router-link>
          </div>
        </div>
      </div>
    </div>    
  </div>
</template>

<script setup>
import { ref } from "vue";
import axios from "axios";
import ToastAlert from "@/commond/ToastAlert.vue";
import HeaderComponent from "@/components/login/HeaderComponent.vue";
import { useRouter } from "vue-router";
let router = useRouter();

let page_view = ref("login");

let email       = ref("");
let toastAlert  = ref(false);
let typeMsg     = ref("");
let msg         = ref("");
let emailError = ref(false);
let emailErrorMessage = ref("");

let loader = ref(false);

async function Restore() {
  // Reset error state
  emailError.value = false;
  emailErrorMessage.value = "";
  
  // Validate email is not empty
  if (email.value == "") {
    emailError.value = true;
    emailErrorMessage.value = "Campo obligatorio";
    showToast('danger', 'Hubo un error, favor de revisar que el correo sea el correcto');
    return false;
  }
  
  // Validate email format
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email.value)) {
    emailError.value = true;
    emailErrorMessage.value = "El correo no es válido";
    showToast('danger', 'Hubo un error, favor de revisar que el correo sea el correcto');
    return false;
  }

  let params = { email: email.value, type_account: 3 };
  try {
    const response = await axios.post(
      `${process.env.VUE_APP_API_BASE_URL}/restore_account`,
      params
    );

    if (response.status == 200) {      
      showToast('success', response.data.message )
      setTimeout(() => {
        router.push({ name: "login" });  
      }, 5000); // ahora espera 5000 ms (5 segundos)
      
      return false;
    }

  } catch (error) {
    if (error.response.status == 422) {
      showToast('danger', 'No se pudo concretar')
    }
  }
}

async function showToast( type = null, message = null){
  toastAlert.value  = true;
  typeMsg.value     = type;
  msg.value         = message;

  setTimeout(() => {
    closeToast();
  }, 5000);
}

async function closeToast() {
  toastAlert.value = false;
  typeMsg.value = "";
  msg.value = "";
}

function clearEmailErrorIfNotEmpty() {
  // Solo limpiar el error si es "Campo obligatorio" y el campo ya no está vacío
  if (emailError.value && emailErrorMessage.value === "Campo obligatorio" && email.value.trim() !== "") {
    emailError.value = false;
    emailErrorMessage.value = "";
  }
}

</script>
  
<style scoped>
/* Si el label tiene clases predeterminadas de Flowbite/Tailwind, puedes sobrescribirlas */
::v-deep .custom-label label {
  @apply text-custom_gray;
  @apply bg-white;
}

/* También puedes apuntar directamente al selector completo */
::v-deep .custom-label label.block.mb-2.text-sm.font-medium {
  @apply text-custom_gray;
  @apply bg-white;
}
</style>